import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {useSelector} from 'react-redux'

// https://doc2.ixiaochuan.cn/pages/viewpage.action?pageId=41440854
export const salary_feedback = createAsyncThunk(
  '/live/union/salary_feedback',
  async (answer, store) => {
    const resp = await http.post<HiyaRes<typeof initialState>>(
      '/live/union/salary_feedback',
      store.getState().env.deviceinfo
    )
    return resp.data.data
  }
)

export const submit_feedback = createAsyncThunk(
  '/live/union/submit_feedback',
  async (data: Omit<typeof initialState, 'button_typ'>, store) => {
    const resp = await http.post<
      HiyaRes<{
        err_msg: string
        status: 0 | 1
      }>
    >('/live/union/submit_feedback', {
      ...store.getState().env.deviceinfo,
      ...data,
    })
    return resp.data.data
  }
)

const initialState: {
  month?: string
  whats_app?: string
  feedback?: string
  button_typ?: 0 | 1 | 2 | 3
} = {}

export const SalaryFeedbackSlice = createSlice({
  name: 'Animal_Narwhal',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(salary_feedback.fulfilled, (state, action) => {
      Object.assign(state, action.payload)
    })
  },
})
export const SalaryFeedbackSliceActions = SalaryFeedbackSlice.actions
export default SalaryFeedbackSlice.reducer
export const useSalaryFeedbackState = () => {
  const data = useSelector((state) => state.Animal_Narwhal)
  return data
}
